export default __webpack_public_path__ + "static/media/about_you.56c14815.webp";